import { BUTTON_SECONDARY_ACTIVE_FILL, CALYPSO_LIGHT, CALYPSO_MEDIUM, CANDY_APPLE_LIGHT, CANDY_APPLE_MEDIUM, OZ_LIGHT, OZ_MEDIUM, SORBET_DARK } from 'HubStyleTokens/colors';
export const CalloutTypes = {
  tip: {
    accentColor: CALYPSO_MEDIUM,
    backgroundColor: CALYPSO_LIGHT
  },
  note: {
    accentColor: OZ_MEDIUM,
    backgroundColor: OZ_LIGHT
  },
  caution: {
    accentColor: CANDY_APPLE_MEDIUM,
    backgroundColor: CANDY_APPLE_LIGHT
  },
  warning: {
    accentColor: SORBET_DARK,
    backgroundColor: BUTTON_SECONDARY_ACTIVE_FILL
  }
};